import { Component, OnInit } from '@angular/core';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { KomitentObjekat } from './komitent-objekat';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-komitent-objekat',
  templateUrl: './komitent-objekat.component.html'
})
export class KomitentObjekatComponent extends BaseModalContainer<KomitentObjekat> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<KomitentObjekat>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) { 
    super(modalContainerService, activatedRoute, modalService, userService);
  }

}
